import {api} from "./api";
import {MODERATOR_COURSE_CATEGORY} from "../mock/URLs";
import {GetCoursesResponse, ICourseByIdItem} from "../types/course";

export const getCourses = async ({params}) => {
  try {
    const {data} = await api.get<GetCoursesResponse>(MODERATOR_COURSE_CATEGORY, {params})
    return data
  } catch (e) {
    throw e
  }
}

export const createCourse = async (values: FormData) => {
  try {
    const {data} = await api.post(MODERATOR_COURSE_CATEGORY, values)
    return data
  } catch (e) {
    throw e
  }
}

export const getCourseById = async (id: number) => {
  try {
    const {data} = await api.get<{ data: ICourseByIdItem }>(`${MODERATOR_COURSE_CATEGORY}${id}/`)
    return data.data
  } catch (e) {
    throw e
  }
}

export const updateCourse = async (id: number, values: FormData) => {
  try {
    const {data} = await api.patch(`${MODERATOR_COURSE_CATEGORY}${id}/`, values)
    return data.data
  } catch (e) {
    throw e
  }
}